<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->

  <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>

    <el-container class="main-con" style="height:calc(100vh - 60px)">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-main class="index-main">
        <tags></tags>
        <div class="main">
          <!--  需要缓存的组件 -->
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" ref="currRoutePage" :key="$route.path"></router-view>
          </keep-alive>
          <!-- 不需要缓存的组件 -->
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
  // 导入组件
  import navcon from '../components/navcon.vue'
  import tags from '../components/tags.vue'
  import leftnav from '../components/leftnav.vue'
  import bus from '@/utils/bus'

  export default {
    name: 'index',
    data() {
      return {
        showclass: 'asideshow',
        showtype: false,
        tabList:[
          {
            func_url: '/Document/typeDocument',
            label: 'API类型管理',
            func_name: 'API类型管理',
            icon: 'Document'
          }
        ]
      }
    },
    // 注册组件
    components: {
      navcon,
      leftnav,
      tags
    },
    computed:{
      fullPath() {
        // console.log(this.$route.fullPath);
        return this.$route.fullPath;
      },
    },
    mounted() {
      this.$bus.$on("clearKeepAlive", this.clearKeepAlive);
    },
    methods: {
      // 根据fullUrl清除keepAlive
      clearKeepAlive(fullUrl) {
        // console.log('bus触发要清除的keepAlive', fullUrl);
        if(this.$refs.currRoutePage){
          const {cache, keys} = this.$refs.currRoutePage.$options.parent;
          delete cache[fullUrl.func_url]
          keys.splice(0, 1)
          this.$children.forEach((item) => {
            if (item.$vnode.data.key == fullUrl) {
              console.log(item.$vnode.data.key);
              this._myDestory(item);
            }
          });
        }
      },
      // 封装清除某个组件的keepAlive状态,并销毁
      _myDestory(keepAliveComponent) {
        // 你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。
        if (
          keepAliveComponent.$vnode &&
          keepAliveComponent.$vnode.data.keepAlive
        ) {
          if (
            keepAliveComponent.$vnode.parent &&
            keepAliveComponent.$vnode.parent.componentInstance &&
            keepAliveComponent.$vnode.parent.componentInstance.cache
          ) {
            if (keepAliveComponent.$vnode.componentOptions) {
              var key =
                keepAliveComponent.$vnode.key == null
                  ? keepAliveComponent.$vnode.componentOptions.Ctor.cid +
                  (keepAliveComponent.$vnode.componentOptions.tag
                    ? `::${keepAliveComponent.$vnode.componentOptions.tag}`
                    : "")
                  : keepAliveComponent.$vnode.key;
              var cache =
                keepAliveComponent.$vnode.parent.componentInstance.cache;
              var keys = keepAliveComponent.$vnode.parent.componentInstance.keys;
              if (cache[key]) {
                if (keys.length) {
                  var index = keys.indexOf(key);
                  if (index > -1) {
                    keys.splice(index, 1);
                  }
                }
                delete cache[key];
              }
            }
          }
        }
        keepAliveComponent.$destroy();
      },
    },
    created() {
      // 监听
      this.$root.Bus.$on('toggle', value => {
        if (value) {
          this.showclass = 'asideshow'
        } else {
          setTimeout(() => {
            this.showclass = 'aside'
          }, 300)
        }
      })
    },
    beforeUpdate() {
    },
    // 挂载前状态(里面是操作)
    beforeMount() {
      let tag = {
        func_url: this.$route.path,
        func_name: this.$route.name
      }
      this.$store.commit('selectMenu', tag)
    },
  }
</script>
<style>
  .index-con {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  .aside {
    width: 64px !important;
    height: 100%;
    background-color: #334157;
    margin: 0px;
  }

  .asideshow {
    width: 240px !important;
    height: 100%;
    background-color: #fff;
    margin: 0px;
  }

  .index-header {
    padding: 0px;
    /*border-left: 2px solid #333;*/
  }

  .index-main {
    padding-top: 10px;
    height: calc(100vh - 60px);
    overflow: hidden;
  }

  .main {
    overflow: auto;
    height: calc(100% - 25px);
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue